<template>
    <EditingDialog
        :context="context"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
    >
        <template v-slot:editForm>
            <v-row>
                <v-col>
                    <v-row>
                        <v-col>
                            <BaseEditPageDropdown 
                                :label="$t('lang_LABEL_RELEASE_CAPTION_TYPE')" 
                                :items="typeItems" 
                                :context="context"
                                field="Type"
                                :alvqa="alvqa + '-dropdown-type'"
                                rules="required"
                                :clearable="false"
                            /> 
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <BaseEditPageDropdown 
                                :label="$t('lang_LABEL_RELEASES_CAPTION_LANGUAGE')" 
                                :items="languageItems" 
                                :context="context"
                                field="Language"
                                :alvqa="alvqa + '-dropdown-language'"
                                rules="required"
                                :clearable="false"
                            /> 
                        </v-col>
                    </v-row>
                </v-col>
                <v-col>
                    <BaseEditPageTextarea 
                        :label="$t('lang_LABEL_RELEASES_CAPTION_DESCRIPTION')"
                        field="Description"
                        :context="context"
                        :alvqa="alvqa + '-textarea-description'"
                        rules="required"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

import { DropdownLabelReleasesPromotionalTextType } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "ReleasePromotionalTextsEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextarea,
        BaseEditPageDropdown
    },
    data() {
        return {
            context: 'ReleasesPromotionalTexts',
            alvqa: "label-releases-edit-form-panel-promotional-texts-editing-panel"
        }
    },
    computed: {
        languageItems() { return this.$store.getters.getGeneralLanguages },
        typeItems() { return DropdownLabelReleasesPromotionalTextType }
    }
}
</script>